module.exports = __webpack_public_path__ + "static/img/tips.14f6381f.png";